<template lang="html">
  <div class="text-input d-flex align-items-center"
  @click="openKeyboardDialog()">
    <input
    ref="textInput"
    :value="text"
    @input="textChanged()"
    :placeholder="placeholder"
    >
    <i class="fal fa-times"
    @click="resetString()"
    v-show="text && !isTouchscreen"
    ></i>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { create } from 'vue-modal-dialogs';
import KeyboardInputDialog from '@/components/Dialogs/KeyboardInputDialog';

const keyboardDialog = create(KeyboardInputDialog, 'prevText');

export default {
  model: {
    prop: 'text',
    event: 'change'
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      isTouchscreen: state => state.project.isTouchscreen
    }),
  },
  methods: {
    async openKeyboardDialog() {
      if (this.isTouchscreen) {
        const keyboardText = await keyboardDialog(this.text);
        this.$emit('change', keyboardText);
        this.$emit('textChanged');
      }
    },
    textChanged() {
      this.$emit('change', this.$refs.textInput.value);
      this.$emit('textChanged');
    },
    resetString() {
      this.$emit('reset');
    },
  }
};
</script>

<style lang="scss" scoped>
.text-input {
  position: relative;
  
  > input {
    border: none;
    border-radius: 0.25rem;
    font-family: Scandia-Regular, sans-serif;
    outline: none;
    width: 170px;
    padding: .375rem .75rem;
    height: 34px;

    @media screen and (min-width: $breakpoint-lg) {
      width: 190px;
    }

    @media screen and (max-width: $breakpoint-sm) {
      width: 100%;
    }
  }

  .fa-times {
    position: absolute;
    right: 5px;
    padding: 6px;
    cursor: pointer;

    &:hover {
      color: var(--action);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/TextInput.vue